/* ohp-legal.js — table-of-contents scroll-spy for the legal page section.
   Smooth-scrolls to a heading on click and highlights the active TOC link as
   the reader scrolls, using an IntersectionObserver offset for the sticky
   header. No-ops on pages without the legal page markup. */
document.addEventListener('DOMContentLoaded', function () {
  var tocLinks = document.querySelectorAll('.ohp-legal-toc a');
  var headings = document.querySelectorAll('.ohp-legal-prose h3[id]');

  if (!tocLinks.length || !headings.length) return;

  // Smooth scroll on click.
  tocLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector(this.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Active state on scroll.
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tocLinks.forEach(function (l) { l.classList.remove('active'); });
          var activeLink = document.querySelector('.ohp-legal-toc a[href="#' + entry.target.id + '"]');
          if (activeLink) activeLink.classList.add('active');
        }
      });
    },
    { rootMargin: '-116px 0px -60% 0px' }
  );

  headings.forEach(function (h) { observer.observe(h); });
});
